import { ApiClient } from '../../../infra';
/**
 * A porta: criar conta e recuperar senha.
 *
 * Mora na pasta do CONCEITO. As telas que o usam - criar conta e recuperar senha -
 * sao irmas dentro dele, e nenhuma e dona do assunto sozinha.
 *
 * O login NAO esta aqui: ele termina gravando sessao, e sessao e do `ApiClient`.
 */
export class AccountApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new AccountApi(); }
    /**
     * Entrar.
     *
     * Mora aqui e nao no `ApiClient` porque entrar e uma ACAO da conta; o que o
     * cliente guarda e a sessao que sai dela. Por isso a ultima linha grava: quem
     * sabe o que e um token e ele, quem sabe o que e um login e este assunto.
     *
     * O `credentialAtStake` e o que faz a porta dizer "E-mail e/ou senha
     * incorretos", que e a mensagem do proprio servidor, em vez de "Sessão
     * expirada" - a traducao que vale para todo o resto do painel.
     */
    async signIn(username, password) {
        const session = (await this.client.send('POST', '/v2/auth/sign-in', { username, password }, undefined, {
            credentialAtStake: true
        }));
        this.client.storeSession(session);
        return session;
    }
    /**
     * Pede o codigo de cinco caracteres por e-mail.
     *
     * O e-mail vai na QUERY, nao no corpo: e como o endpoint publico do legado o
     * espera (`POST /v2/auth/password-reset`, publico).
     */
    async requestPasswordReset(email) {
        await this.client.send('POST', `/v2/auth/password-reset?email=${encodeURIComponent(email)}`);
    }
    /**
     * Troca o codigo por um token temporario.
     *
     * O codigo expira em TRES minutos (`PasswordResetService`), e por isso a tela
     * mostra um relogio. Um codigo errado volta 4xx - e credencial recusada, nao
     * sessao expirada.
     */
    async confirmResetCode(email, code) {
        const answer = (await this.client.send('POST', '/v2/auth/password-reset/verify-code', { email, code }, undefined, {
            credentialAtStake: true
        }));
        return answer.token;
    }
    /**
     * Grava a senha nova, com o token temporario no cabecalho.
     *
     * O token NAO vira sessao: quem acabou de trocar a senha volta para a porta e
     * entra com ela, como no painel antigo.
     */
    async confirmNewPassword(email, password, token) {
        await this.client.send('POST', '/v2/auth/password-reset/confirm', { email, password }, undefined, {
            bearer: token,
            credentialAtStake: true
        });
    }
}
//# sourceMappingURL=account.api.js.map